// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateNewStrategyBox_container__39YT3"};